// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { State, StateT } from '../tbs/state.js';


export class SetStateAction implements flatbuffers.IUnpackableObject<SetStateActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SetStateAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSetStateAction(bb:flatbuffers.ByteBuffer, obj?:SetStateAction):SetStateAction {
  return (obj || new SetStateAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSetStateAction(bb:flatbuffers.ByteBuffer, obj?:SetStateAction):SetStateAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SetStateAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapSetState;
}

state(obj?:State):State|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new State()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startSetStateAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapSetState);
}

static addState(builder:flatbuffers.Builder, stateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, stateOffset, 0);
}

static endSetStateAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): SetStateActionT {
  return new SetStateActionT(
    this.type(),
    (this.state() !== null ? this.state()!.unpack() : null)
  );
}


unpackTo(_o: SetStateActionT): void {
  _o.type = this.type();
  _o.state = (this.state() !== null ? this.state()!.unpack() : null);
}
}

export class SetStateActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapSetState,
  public state: StateT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const state = (this.state !== null ? this.state!.pack(builder) : 0);

  SetStateAction.startSetStateAction(builder);
  SetStateAction.addType(builder, this.type);
  SetStateAction.addState(builder, state);

  return SetStateAction.endSetStateAction(builder);
}
}
